export default __webpack_public_path__ + "static/media/arrival-banner-6.fd8e4888.jpg";